import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Resolve } from '@angular/router';
import { QUERY_PARAMS_MAP } from './query-params.map';
import { RedirectResolverOutput } from './types';

@Injectable({
  providedIn: 'root',
})
export class RedirectResolver implements Resolve<RedirectResolverOutput> {
  resolve(route: ActivatedRouteSnapshot, _: RouterStateSnapshot): RedirectResolverOutput {
    const r2: unknown = route.queryParams[QUERY_PARAMS_MAP.redirectTo];
    // A repeated r2 arrives as an array: treat anything but a single string as missing (falls back to '/').
    return RedirectResolver.parseRedirectParam(typeof r2 === 'string' ? r2 : '');
  }

  static parseRedirectParam(param: string): RedirectResolverOutput {
    const exist = !!param;
    const [path = '', queryString = ''] = param.split('?');
    // URLSearchParams already decodes values; decoding again corrupts or throws on a literal '%'.
    const queryParams = new URLSearchParams(queryString);

    return {
      exist,
      path: path ? [path] : [],
      queryParams: [...queryParams.entries()].reduce<Record<string, string>>(
        (acc, [key, value]) => ({
          ...acc,
          [key]: value,
        }),
        {},
      ),
    };
  }
}
